import React from 'react';
import emergencyIcon from '../../shared/assets/emergency.svg';
import SVGInline from 'react-svg-inline';

export default class EmergencyCareBanner extends React.Component {
  render() {
    return (
      <div className={`emergency-banner ${this.props.cms ? 'cms-action' : ''}`}>
        <span className="action-label">
          <SVGInline svg={emergencyIcon} /> Emergency Care
        </span>
        {/* <div className="tooltip">
          <div className="circle">
            <SVGInline svg={emergencyIcon} />
          </div>
          <div className="tip-text">
            Emergency care is available at this location.
          </div>
        </div> */}
      </div>
    );
  }
}
